import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { acceptInvitation } from '../services/familyApi';
import '../styles/Auth.css';

export default function FamilyAcceptPage() {
  const { token }  = useParams();
  const navigate   = useNavigate();
  const [loading, setLoading] = useState(true);
  const [result, setResult]   = useState(null);
  const [error, setError]     = useState(null);

  useEffect(() => {
    acceptInvitation(token)
      .then(res => setResult(res.data))
      .catch(err => setError(err.response?.data?.message || 'Failed to accept invitation'))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) {
    return (
      <div className="auth-container">
        <div className="auth-card" style={{ textAlign: 'center', padding: '3rem 2rem' }}>
          <p>Accepting invitation…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        {error ? (
          <>
            <h1>⚠ Invitation Error</h1>
            <div className="alert alert-error">{error}</div>
            <button
              className="btn btn-primary"
              style={{ marginTop: '1.5rem' }}
              onClick={() => navigate('/dashboard')}
            >
              Go to Dashboard
            </button>
          </>
        ) : (
          <>
            <h1>👨‍👩‍👧‍👦 {result?.message || 'Welcome!'}</h1>
            <p className="auth-subtitle">
              You've been added to the family group
              {result?.group?.name ? ` "${result.group.name}"` : ''}.
              You can now view family members' profiles and pets.
            </p>
            <div className="alert alert-success">✓ Invitation accepted!</div>
            <button
              className="btn btn-primary"
              style={{ marginTop: '1.5rem' }}
              onClick={() => navigate('/dashboard')}
            >
              Go to Dashboard
            </button>
          </>
        )}
      </div>
    </div>
  );
}
